import { render, staticRenderFns } from "./ViewOrderModal.vue?vue&type=template&id=36a3f630&scoped=true&"
import script from "./ViewOrderModal.vue?vue&type=script&lang=js&"
export * from "./ViewOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewOrderModal.vue?vue&type=style&index=0&id=36a3f630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a3f630",
  null
  
)

export default component.exports